import React from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from './ui/select';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from './ui/popover';
import { Calendar, Filter, X } from 'lucide-react';

export const DateFilter = ({ 
  startDate, 
  setStartDate, 
  endDate, 
  setEndDate, 
  month, 
  setMonth,
  onApply,
  onClear,
  showMonthFilter = true 
}) => {
  // Generate last 12 months
  const months = [];
  const today = new Date();
  for (let i = 0; i < 12; i++) {
    const d = new Date(today.getFullYear(), today.getMonth() - i, 1);
    const value = d.toISOString().slice(0, 7);
    const label = d.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
    months.push({ value, label });
  }

  const hasFilters = startDate || endDate || month;

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="outline" size="sm" className="gap-2">
          <Filter className="w-4 h-4" />
          Date Filter
          {hasFilters && (
            <span className="bg-primary text-primary-foreground rounded-full w-5 h-5 text-xs flex items-center justify-center">
              !
            </span>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-80" align="end">
        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <h4 className="font-semibold text-sm">Filter by Date</h4>
            {hasFilters && (
              <Button variant="ghost" size="sm" onClick={onClear} className="h-8 px-2 text-xs">
                <X className="w-3 h-3 mr-1" /> Clear
              </Button>
            )}
          </div>
          
          {showMonthFilter && (
            <div className="space-y-2">
              <Label className="text-xs">Quick Select Month</Label>
              <Select value={month || 'all'} onValueChange={(v) => {
                setMonth(v === 'all' ? '' : v);
                setStartDate('');
                setEndDate('');
              }}>
                <SelectTrigger className="h-9">
                  <SelectValue placeholder="Select month" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="all">All Time</SelectItem>
                  {months.map((m) => (
                    <SelectItem key={m.value} value={m.value}>{m.label}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
          )}

          <div className="relative">
            <div className="absolute inset-0 flex items-center">
              <span className="w-full border-t" />
            </div>
            <div className="relative flex justify-center text-xs uppercase">
              <span className="bg-popover px-2 text-muted-foreground">Or date range</span>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-3">
            <div className="space-y-2">
              <Label className="text-xs">From</Label>
              <Input
                type="date"
                value={startDate}
                onChange={(e) => {
                  setStartDate(e.target.value);
                  setMonth('');
                }}
                className="h-9"
              />
            </div>
            <div className="space-y-2">
              <Label className="text-xs">To</Label>
              <Input
                type="date"
                value={endDate}
                onChange={(e) => {
                  setEndDate(e.target.value);
                  setMonth('');
                }}
                className="h-9"
              />
            </div>
          </div>

          <Button onClick={onApply} className="w-full" size="sm" style={{ backgroundColor: '#383838' }}>
            Apply Filter
          </Button>
        </div>
      </PopoverContent>
    </Popover>
  );
};
